export default __webpack_public_path__ + "static/media/header-bg-kalendar-1.27fa1547.jpg";